<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="3" sm="5" xs="12">
                                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dataIni" label="Inizio" prepend-icon="mdi-calendar" readonly
                                            v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker @change="listaIncassiData(dataIni, selectedShop)" v-model="dataIni"
                                        type="month"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="3" sm="5" xs="12">
                                <div>
                                    <v-select :items="arrShops" v-model="selectedShop" label="Negozi"
                                        @change="listaIncassiData(dataIni, selectedShop)" item-text="description"
                                        item-value="id">
                                    </v-select>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-expansion-panels v-model="panel">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <b>TOTALI</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>

                            <div v-if="listaIncassi.length > 0">
                                <v-row>
                                    <v-col>
                                        Incasso: <b>{{ totali.incasso | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        POS: <b>{{ totali.pos | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Satispay: <b>{{ totali.satispay | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Spese: <b>{{ totali.spese | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Contanti: <b>{{ totali.contanti | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Spiccioli: <b>{{ totali.spiccioli | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Versamenti: <b>{{ totali.versamento | formatEuro }} </b>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        Iva 22%: <b>{{ totali.iva22 | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Iva 10%: <b>{{ totali.iva10 | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Iva 5%: <b>{{ totali.iva5 | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Iva 4%: <b>{{ totali.iva4 | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        IVA: <b>{{ totali.totale | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Scontrini: <b>{{ totali.num_scontrini }} </b>
                                    </v-col>
                                    <v-col>
                                        Cont. Pers.: <b>{{ totali.conta_persone }} </b>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        Media Scontrini: <b>{{ totali.media_scontrino | formatEuro }} </b>
                                    </v-col>
                                    <v-col>
                                        Media Scontrini Giorn.: <b>{{ totali.media_scontrino_giornaliero }} </b>
                                    </v-col>
                                    <v-col>
                                        Media Persone Giorn.: <b>{{ totali.media_persone_giornaliero }} </b>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <v-data-table :hide-default-footer="true" :item-class="itemRowBackground" :headers="headers"
                    :items="listaIncassi" :items-per-page="50" :footer-props="{
                            'items-per-page-options': [20, 50, 100, 200, -1],
                        }" item-key="id" class="elevation-1" :loading="loading" group-by="day_of_week"
                    :show-group-by="false" loading-text="Caricamento in corso..." calculate-widths>
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Lista Incassi</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-btn @click="dialog = true" color="primary"><v-icon>mdi-plus</v-icon>Aggiungi</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="success"
                                :href="'/api/incassi-export?data_ini=' + dataIni + '&shop_id=' + selectedShop">
                                <v-icon> mdi-download </v-icon> Esporta
                            </v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="editIncasso = item; dialog = true">
                            mdi-pencil
                        </v-icon>
                        <v-icon small @click=" deleteIncasso(item) "> mdi-delete </v-icon>
                    </template>
                    <template v-slot:item.data_incasso=" { item } ">
                        <b>{{ item.data_incasso }}</b>
                    </template>
                    <template v-slot:item.incasso=" { item } ">
                        <b>{{ item.incasso | formatEuro }}</b>
                    </template>
                    <template v-slot:item.pos=" { item } ">
                        {{ item.pos | formatEuro }}
                    </template>
                    <template v-slot:item.satispay=" { item } ">
                        {{ item.satispay | formatEuro }}
                    </template>
                    <template v-slot:item.spese=" { item } ">
                        {{ item.spese | formatEuro }}
                    </template>
                    <template v-slot:item.contanti=" { item } ">
                        {{ item.contanti | formatEuro }}
                    </template>
                    <template v-slot:item.spiccioli=" { item } ">
                        {{ item.spiccioli | formatEuro }}
                    </template>
                    <template v-slot:item.versamento=" { item } ">
                        {{ item.versamento | formatEuro }}
                    </template>
                    <template v-slot:item.iva22=" { item } ">
                        {{ item.iva22 | formatEuro }}
                    </template>
                    <template v-slot:item.iva10=" { item } ">
                        {{ item.iva10 | formatEuro }}
                    </template>
                    <template v-slot:item.iva5=" { item } ">
                        {{ item.iva5 | formatEuro }}
                    </template>
                    <template v-slot:item.iva4=" { item } ">
                        {{ item.iva4 | formatEuro }}
                    </template>
                    <template v-slot:item.totale=" { item } ">
                        {{ item.totale | formatEuro }}
                    </template>
                    <template v-slot:item.media_scontrino=" { item } ">
                        {{ item.media_scontrino | formatEuro }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <DialogIncassiVue class="v-data-table-header" @onClose=" onCloseDialog() " @onSave=" onSaveDialog " :arr-shop=" arrShops "
            :open=" dialog " :incasso=" editIncasso ">
        </DialogIncassiVue>
    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep {
    .v-data-table-header {
        background-color: #ffff99;

    }

    .back-red {
        background-color: rgb(255, 215, 215);
    }
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: black;
}
</style>
<script>
import requests from "../../requests";
import DialogIncassiVue from "./DialogIncassi.vue";
export default {
    name: "inscassi-list-page",
    components: {
        DialogIncassiVue
    },
    computed: {
        headers() {
            return [
                { text: "Data", value: "data_incasso", width: "110px", divider: true },
                { text: "Giorno", value: "giorno", width: "90px", divider: true },
                { text: "Incasso", value: "incasso", width: "100px", divider: true },
                { text: "POS", value: "pos", width: "100px", divider: true },
                { text: "Satispay", value: "satispay", width: "100px", divider: true },
                { text: "Spese", value: "spese", width: "100px", divider: true },
                { text: "Contanti", value: "contanti", width: "100px", divider: true },
                { text: "Spiccioli", value: "spiccioli", width: "100px", divider: true },
                { text: "Vers.", value: "versamento", width: "100px", divider: true },
                { text: "Iva 22%", value: "iva22", width: "100px", divider: true },
                { text: "Iva 10%", value: "iva10", width: "100px", divider: true },
                { text: "Iva 5%", value: "iva5", width: "100px", divider: true },
                { text: "Iva 4%", value: "iva4", width: "100px", divider: true },
                { text: "Totale", value: "totale", width: "100px", divider: true },
                { text: "Num Scontrini", value: "num_scontrini", divider: true },
                { text: "Media Scontrino", value: "media_scontrino", width: "100px", divider: true },
                { text: "Cont. Pers.", value: "conta_persone", width: "100px", divider: true },
                { text: "Operatore", value: "operatore", divider: true },
                { text: "Meteo", value: "meteo", divider: true },
                { text: "Note", value: "note", divider: true },
                { text: "Azioni", value: "actions", width: "80px", divider: true },
            ]
        }
    },
    data: () => {
        return {
            menu: false,
            dataIni: null,
            loading: false,
            listaIncassi: [],
            dialog: false,
            arrShops: [],
            selectedShop: 0,
            editIncasso: {},
            panel: 0,
            totali: {}
        };
    },
    mounted() {
        console.log("Incassi List Mounted.");
        this.dataIni = this.$moment().startOf('month').format('YYYY-MM');
        this.loading = true;

        this.getShopList();
    },
    methods: {
        onCloseDialog() {
            this.dialog = false;
        },
        getShopList() {
            requests.getShopList().then(res => {
                this.arrShops = res.data;
                this.selectedShop = this.arrShops[0].id;
                this.listaIncassiData(this.dataIni, this.selectedShop);
            })
        },
        listaIncassiData(dIni, shopId) {
            requests.getListaIncassi(dIni, shopId).then(res => {
                this.listaIncassi = res.data;
                this.calcoloTotali(res.data);
                this.loading = false;
            });
        },

        onSaveDialog(data) {
            requests.saveIncassi(data).then(res => {
                this.listaIncassiData(this.dataIni, this.selectedShop);
                this.dialog = false;
            });
            console.log("save");
        },

        deleteIncasso(item) {
            if (window.confirm('Cancellare l\'incasso?')) {
                requests.deleteIncassi(item.id).then(res => {
                    if (!res.data.result) window.alert('Cancellazione non permessa.');
                    else this.listaIncassiData(this.dataIni, this.selectedShop);
                });
            }
        },

        calcoloTotali(datiTotali) {
            this.totali = {};
            let arrField = [
                'incasso', 'pos', 'satispay', 'spese',
                'versamento', 'iva22', 'iva10', 'iva5', 'iva4',
                'num_scontrini', /*'media_scontrino'*/, 'contanti',
                'spiccioli', 'totale', 'conta_persone'
            ];

            _.forEach(arrField, (field) => {
                _.forEach(datiTotali, (value) => {
                    if (_.isUndefined(this.totali[field])) {
                        this.$set(this.totali, field, 0);
                    }
                    this.totali[field] += value[field]
                });
            });

            this.totali['media_scontrino'] = this.totali.incasso / this.totali.num_scontrini;
            //Math.round((num + Number.EPSILON) * 100) / 100

            let incassiReali = this.countIncassiReali(this.listaIncassi)

            var num = Math.round((this.totali.num_scontrini / incassiReali + Number.EPSILON) * 100) / 100
            this.totali['media_scontrino_giornaliero'] = num;

            var num = Math.round((this.totali.conta_persone / incassiReali + Number.EPSILON) * 100) / 100
            this.totali['media_persone_giornaliero'] = num;
        },
        itemRowBackground: function (item) {
            return item.fake ? 'back-red' : '';
        },

        countIncassiReali(listaIncassi) {
            let cont = 0;
            _.each(listaIncassi, (val) => {
                if (val.incasso != 0) cont++;
            });
            return cont;
        }

    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    }
};
</script>
